import { useEffect, useState } from "react";
import { getMe } from "../api/routes";
import { toast } from "react-toastify";

export default function useMe(){
  const [me, setMe] = useState([]);

  useEffect(() => {
    if (sessionStorage.getItem('x-auth-token')) {
      getMe((isOk, data) => {
        if (!isOk) {
          return toast.error(data.message)
        } else {
          sessionStorage.setItem("fullname", data[0]?.fullname)
          return setMe(data[0])
        }
      })
    }
  }, [sessionStorage.getItem('x-auth-token')])
  return [me]
}
